export default "__VITE_ASSET__16361981__"